<template>
    <div class="saleinvoice-list">
        <Row>
            <Col :xs="24" :sm="24">
            <Form :inline="true" action="javascrpt:void(0)">
                <FormItem>
                    <Button @click="showModel()" type="success" class="f-r">添加规则</Button>
                </FormItem>
            </Form>
            </Col>
        </Row>
        <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
        <!-- 添加的弹出 -->
        <Modal v-model="showModalStatus" title="添加规则" @on-ok="createRule('ruleValidate')" :loading="loading">
            <Form :model="rule" ref="ruleValidate" :rules="ruleValidate" action="javascript:void(0)">
                <FormItem label="发票类型" label-position="invoice_type">
                    <RadioGroup v-model="rule.invoice_type">
                        <Radio :label="0">普票</Radio>
                        <Radio :label="1">专票</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="税点" prop="tax_point">
                    <Input v-model="rule.tax_point" placeholder="输入税点..."></Input>
                </FormItem>
                <FormItem label="最高平台进价" prop="plat_price">
                    <Input v-model="rule.plat_price" placeholder="输入最高平台进价..."></Input>
                </FormItem>
            </Form>
        </Modal>
        <!-- 修改的弹出 -->
        <Modal v-model="showEditInfoStatus" title="修改规则" @on-ok="updateRule('ruleValidate')" :loading="loading">
            <Form :model="rule" ref="ruleValidate" :rules="ruleValidate" action="javascript:void(0)">
                <FormItem label="发票类型" label-position="invoice_type">
                    <RadioGroup v-model="rule.invoice_type">
                        <Radio :label="0">普票</Radio>
                        <Radio :label="1">专票</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="税点" prop="tax_point">
                    <Input v-model="rule.tax_point" placeholder="输入税点..."></Input>
                </FormItem>
                <FormItem label="最高平台进价" prop="plat_price">
                    <Input v-model="rule.plat_price" placeholder="输入最高平台进价..."></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: 'saleinvoice-list',
        data() {
            return {
                loading: true,
                dataloading: true,
                test: 1,
                columns1: [
                    {
                        title: 'Id',
                        key: 'id',
                        width: 100,
                        fixed: 'left'
                    },
                    {
                        title: '发票类型',
                        key: 'invoice_type',
                        minWidth: 80,
                        render: (h, params) => {
                            return h("div", [h("span", {}, params.row.invoice_type == 1 ? '专票' : '普票')]);
                        }
                        // return h('div', params.row.receipt_status == "1" ? '已收货' : '未收货')
                    },
                    {
                        title: '税点',
                        key: 'tax_point',
                        width: 80,
                    },
                    {
                        title: '最高平台进价',
                        key: 'plat_price',
                        width: 80,
                    },
                    {
                        title: '操作',
                        key: 'action',
                        with: 300,
                        align: 'right',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.showEditInfo(params.row.id)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(params.row.id)
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                tablelist: [],
                rule: {
                    invoice_type: '0',
                    tax_point: '0',
                    plat_price: '0'
                },
                showModalStatus: false,
                showEditInfoStatus: false,
                ruleValidate: {
                    // tax_point: [
                    //     { required: true, message: '税点必须填写', trigger: 'blur' }
                    // ],
                    // plat_price: [
                    //     { required: true, message: '最高平台进价比例必须填写', trigger: 'blur' }
                    // ]
                },
            }
        },
        // 计算
        computed: {},
        // 监听
        watch: {},
        created: function () {
            // 取数据
            this.getTableList();
        },
        methods: {
            getTableList: function () {
                var self = this;
                this.$api.saleinvoice.list().then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        self.tablelist = res.result;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            // 展开添加
            showModel() {
                this.$refs['ruleValidate'].resetFields();
                this.showModalStatus = !this.showModalStatus;
            },
            // 添加
            createRule(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$api.saleinvoice.create({
                            invoice_type: this.rule.invoice_type,
                            tax_point: this.rule.tax_point,
                            plat_price: this.rule.plat_price
                        }).then(res => {
                            if (res.code == 200) {
                                this.showModalStatus = !this.showModalStatus;
                                this.getTableList();
                            }
                        });
                        this.loading = false
                        this.$nextTick(() => {
                            this.loading = true;
                        });
                    } else {
                        this.$Message.error('请检查输入的信息是否正确！');
                        this.loading = false
                        this.$nextTick(() => {
                            this.loading = true;
                        });
                    }
                })
            },
            //展开修改
            showEditInfo: function (index) {
                this.ruleid = index;
                this.$refs['ruleValidate'].resetFields();
                this.showEditInfoStatus = !this.showEditInfoStatus;
                // 取信息
                this.$api.saleinvoice.detail({ruleid: index}).then(res => {
                    if (res.code == 200) {
                        this.rule = res.result;
                        this.$Message.success(res.msg);
                    }
                    this.loading = false;
                    this.$nextTick(() => {
                        this.loading = true;
                    });
                });
            },
            // 修改名称
            updateRule: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        console.log(this.rule);
                        this.$api.saleinvoice.edit({
                            rule_id: this.ruleid,
                            invoice_type: this.rule.invoice_type,
                            tax_point: this.rule.tax_point,
                            plat_price: this.rule.plat_price
                        }).then(res => {
                            if (res.code == 200) {
                                this.$Message.success(res.msg);
                                this.showEditInfoStatus = !this.showEditInfoStatus;
                                this.getTableList();
                            }
                            this.loading = false;
                            this.$nextTick(() => {
                                this.loading = true;
                            });
                            this.showCreateStatus = !this.showCreateStatus;
                        });
                    } else {
                        this.$Message.error('请检查输入的信息是否正确！');
                        this.loading = false
                        this.$nextTick(() => {
                            this.loading = true;
                        });
                    }
                })
            },
            remove: function (index) {
                // 弹出确认框
                this.$Modal.confirm({
                    title: '警告',
                    content: '<p>此操作不可恢复，三思而后行...</p>',
                    onOk: () => {
                        this.$api.saleinvoice.remove({rule_id: index}).then(res => {
                            if (res.code == 200) {
                                this.$Message.success(res.msg);
                                // this.tablelist.splice(index, 1);
                                this.getTableList();
                            }
                        });
                    }
                });
            },
        },
    }
</script>
